import React, { createRef } from "react";
import { OrderedMap, Map, Set } from "immutable";
import { PropTypes } from "prop-types";
import Question from "./question.jsx";
import T from "./t.jsx";
import { COMPONENTS as ICOMPONENTS } from "./identification.jsx";
import { TYPES as ITYPES } from "./identification.jsx";
import { SecondarySign, Sign } from "./sign.jsx";
import SubmitterEmail from "./submitterEmail.jsx";
import SignEmails from "./signEmails.jsx";
import classNames from "classnames";
import qs from "qs";
import Modal from "react-responsive-modal";
import ReactGA from "react-ga";
import { API_BASE } from "../../config";

var uniqueCounter = 0;
function unique(prefix) {
  return prefix + "_" + uniqueCounter++;
}

function initQuestionData(q) {
  var data = {
    errors: [],
    dirty: false,
  };

  switch (q.type) {
    case "GRID":
      let dataSheet = { ...q.gridData, data: new Array() };

      q.gridData.rows.forEach((column, i) => {
        dataSheet.data[i] = new Array();
        q.gridData.columns.forEach((row, j) => {
          dataSheet.data[i].push("");
        });
      });
      data.datasheet = dataSheet;
      break;
    case "EMAIL":
    case "TEL":
    case "TEXT":
    case "TEXTAREA":
    case "HEADING":
    case "DIVIDER":
    case "DROPDOWNNUMBER":
      data.text = null;

      break;
    case "POLAR":
    case "RADIO":
    case "DROPDOWN":
    case "CHECKBOX":
      data.selected = Set();

      break;
    case "NUMBER":
      data.number = null;

      break;
    case "DATE":
      data.date = null;
      break;
    case "TIME":
      data.time = null;

      break;
    case "LIST":
      data.rows = [];

      break;
    case "FILE":
      data.fileId = null;

    case "CALCULATION":
      data.calculation = null;

      break;
    default:
      throw new Error("Invalid question type '" + q.type + "'");
  }

  return data;
}

function requiredErrors(q) {
  let data = initQuestionData(q);
  let errors = q.required && !q.parentId ? ["question-required"] : [];

  data.errors = errors;

  return [q.id, Map(data)];
}

function questionClasses(question) {
  var cls = {
    question__item: true,
    question__layout: true,
    vertical: question.preferredLayout === "VERTICAL",
    horizontal:
      question.preferredLayout === "HORIZONTAL" &&
      ["CHECKBOX", "RADIO"].indexOf(question.type) !== -1,
    column:
      question.preferredLayout === "HORIZONTAL" &&
      ["CHECKBOX", "RADIO"].indexOf(question.type) === -1,

    question__column:
      ["HALF", "THIRD", "FOURTH"].indexOf(question.preferredWidth) !== -1,
  };

  cls["question__" + question.type.toLowerCase()] = true;

  if (["HALF", "THIRD", "FOURTH"].indexOf(question.preferredWidth) !== -1) {
    cls["question__column--" + question.preferredWidth.toLowerCase()] = true;
  }

  return classNames(cls);
}

/**
 * identificationKey: "NAME"|"COMPANY"|"ADDRESS"|"TELEPHONE"|"EMAIL"|"ORGANIZATION_NUMBER"|"SOCIAL_SECURITY_NUMBER"|"MOBILE_PHONE_NUMBER"
 * questionId: UUID
 *
 * state: Map(
 *   identificationKey: [Map(
 *     "text":   string,
 *     "errors": Array<string>,
 *     "dirty":  boolean
 *   )],
 *   submitterEmail: Map(
 *     "text":   string,
 *     "errors": Array<string>,
 *     "dirty":  boolean
 *   ),
 *   "values": Map(
 *     questionId: Map(
 *       "errors":   Array<string>,
 *       "dirty":    boolean,
 *       "selected": Set<string>|undefined,
 *       "text":     string|undefined,
 *       "number":   string|undefined,
 *       "date":     string|undefined,
 *       "rows":     Array<string>|undefined
 *     )
 *   )
 * )
 */
export class Renderer extends React.Component {
  constructor(props) {
    super(props);
    /* Init with all required-errors to prevent attempts to submit empty form */

    this.formRef = createRef();

    this.state = {
      currentStep: undefined,
      submitting: false,
      keyPrefix: null,
      listLittera: [],
      listAllContacts: [],
      formValid: null,
      open: false,
      helpMessageTitle: "",
      helpMessage: "",
      currentOptionQuestions: [],
      ...this.getCustomerQuestion(props),
      currentTag: "",
    };

    this.formData = this.initialFormData(props);
  }

  getCustomerQuestion = (props) => {
    let customerQuestion = "",
      fixedCustomer = "";
    let orderWebhook = props.webHooks.find(
      (wh) => wh.indexOf("form-create-order") > -1
    );
    if (orderWebhook) {
      let params = qs.parse(orderWebhook);
      if ("true" === params.fixedCustomer) {
        fixedCustomer = params.customerId;
      } else {
        customerQuestion = params.customerQuestion;
      }
    } else {
      let q = props.questions.find(
        (q) =>
          q.type === "LIST" &&
          q.listSource &&
          q.listSource.indexOf("customers") > -1
      );
      if (q) {
        customerQuestion = q.id;
      }
    }
    return {
      fixedCustomer,
      customerQuestion,
    };
  };

  sendEvent = (status) => {
    ReactGA.event({
      category: this.props.publicationId,
      action: "formSubmit",
      label: status || "",
    });
  };

  mutate = (fn, cb) => {
    let formData = fn(this.formData);
    if (formData !== this.formData) {
      this.formData = formData;
      if (typeof this.props.onData === "function") {
        this.props.onData(this.formData.toJS());
      }
      this.forceUpdate(cb);
    }
  };
  initialFormData = (props) => {
    function qData(q) {
      if (
        typeof props.savedState.values === "object" &&
        typeof props.savedState.values[q.id] === "object"
      ) {
        let data = props.savedState.values[q.id];

        if (Array.isArray(data.selected)) {
          data.selected = Set(data.selected);
        }
        return [q.id, Map(data)];
      }
    }

    /* Do not reuse identification */
    let data = Map(
      props.requiredIdentification.map((k) => [
        k,
        Map({ errors: ["identification-required"] }),
      ])
    );

    // We have saved values, use those
    if (props.savedState) {
      data = data.set("values", OrderedMap(props.questions.map(qData)));
    } else {
      data = data.set(
        "values",
        OrderedMap(props.questions.map(requiredErrors))
      );
    }

    /* Do not reuse sign or submitter email */
    return data
      .set(
        "sign",
        Map(
          props.sign ? { lines: [], errors: ["identification-required"] } : {}
        )
      )
      .set(
        "secondarySign",
        Map(props.secondarySign ? { lines: [], errors: [] } : {})
      )
      .set(
        "submitterEmail",
        Map(this.props.submitterCopyEnabled ? { errors: [], dirty: false } : {})
      )
      .set(
        "signEmails",
        Map(
          this.props.multiSign
            ? {
                errors: this.props.multiSignRequired
                  ? ["question-required"]
                  : [],
                dirty: false,
                emails: [],
              }
            : {}
        )
      );
  };

  onInput = (questionId, input) => {
    if (questionId === this.state.customerQuestion) {
      let rows = input.get("rows", []);
      if (rows.length > 0) {
        this.getLittera(rows[0].text.split("_")[0]);
      } else {
        this.setState({
          listLittera: [],
        });
      }
    }
    this.mutate((state) => state.setIn(["values", questionId], input));
  };

  onID = (key, input) => {
    this.mutate((state) =>
      state.set(
        key,
        input.get("errors").length === 0 ? input : input.delete("text")
      )
    );
  };

  getLittera = (customerId) => {
    if (typeof this.props.getLittera === "function") {
      this.props.getLittera(customerId).then((resp) => {
        this.setState({
          listLittera: resp.body.projects,
        });
      });
    }
  };

  onSign = (data) => {
    if (this.props.secondarySign) {
      this.mutate((state) =>
        state.set("sign", data).set(
          "NAME",
          Map({
            text: data.get("name", ""),
            errors: data.get("errors", []),
            dirty: true,
          })
        )
      );
    } else {
      this.mutate((state) => state.set("sign", data));
    }
  };

  onSecondarySign = (data) => {
    this.mutate((state) => state.set("secondarySign", data));
  };

  getFormValues = () => {
    return this.formData
      .get("values", Map())
      .map((v, k) => {
        return {
          questionId: k,
          text: v.has("number") ? v.get("number") : v.get("text", null),
          selected: v.has("selected") ? v.get("selected").toArray() : null,
          number: v.has("number") ? parseFloat(v.get("number")) : null,
          date: v.get("date", null),
          time: v.get("time", null),
          datasheet: v.get("datasheet", null),
          calculation: v.get("calculation", null),
          rows: v.get("rows", null)
            ? v.get("rows", null).map((r) => {
                if (r.num) {
                  let arr = r.text.split("_");
                  let arr1 = arr[1].split(" – ");
                  let text = arr1
                    .filter((v, i) => {
                      return i !== 2;
                    })
                    .join(" – ");

                  return (
                    arr[0] + "_" + r.num + " (" + arr1[2] + ") " + "x " + text
                  );
                }

                return r.text;
              })
            : null,
          fileId: v.get("fileId", null),
        };
      })
      .filter((v) => {
        return (
          v.text !== null ||
          v.selected !== null ||
          v.number !== null ||
          v.date !== null ||
          v.time !== null ||
          v.datasheet !== null ||
          v.rows !== null ||
          v.fileId !== null ||
          v.calculation !== null
        );
      })
      .toArray();
  };

  onSubmit = () => {
    if (this.numErrors() === 0) {
      this.setState({ formValid: true });
      let values = this.getFormValues();
      let data = {
        name: this.formData.getIn(["NAME", "text"], null),
        company: this.formData.getIn(["COMPANY", "text"], null),
        address: this.formData.getIn(["ADDRESS", "text"], null),
        telephone: this.formData.getIn(["TELEPHONE", "text"], null),
        email: this.formData.getIn(["EMAIL", "text"], null),
        organizationNumber: this.formData.getIn(
          ["ORGANIZATION_NUMBER", "text"],
          null
        ),
        socialSecurityNumber: this.formData.getIn(
          ["SOCIAL_SECURITY_NUMBER", "text"],
          null
        ),
        mobilePhoneNumber: this.formData.getIn(
          ["MOBILE_PHONE_NUMBER", "text"],
          null
        ),
        signature: this.formData.getIn(["sign", "image"], null),
        secondarySignature: this.formData.getIn(
          ["secondarySign", "image"],
          null
        ),
        secondaryName: this.formData.getIn(["secondarySign", "name"], null),
        submitterEmail:
          this.props.submitterCopyEnabled &&
          this.formData.getIn(["submitterEmail", "enabled"], false)
            ? this.formData.getIn(["submitterEmail", "text"], null)
            : null,
        signEmails: this.formData.getIn(["signEmails", "emails"], []).filter((e) => e).filter((value, index, self) => self.indexOf(value) === index),
        values: values,
      };

      let r = this.props.onSubmit(data);
      if (r && typeof r.then === "function") {
        let finishSubmit = () => {
          this.setState({
            submitting: false,
          });
        };
        let reset = () => {
          this.setState(
            {
              keyPrefix: unique(this.props.id),
              submitting: false,
            },
            () => {
              this.onClearForm();
            }
          );
        };

        this.setState(
          {
            submitting: true,
          },
          () => {
            r.then(
              () => {
                this.sendEvent("Success");
                reset();
              },
              () => {
                this.sendEvent("Failure");
                finishSubmit();
              }
            );
          }
        );
      } else {
        this.sendEvent();
        this.onClearForm();
      }
    } else {
      this.mutate((state) =>
        state
          /* Mark all values as dirty */
          .update("values", (values) => values.map((d) => d.set("dirty", true)))
          /* Mark identification-fields as dirty */
          .map((v, k) =>
            this.props.requiredIdentification.indexOf(k) !== -1 ||
            (k === "sign" && this.props.sign) ||
            (k === "secondarySign" && this.props.secondarySign)
              ? v.set("dirty", true)
              : v
          )
          .setIn(["submitterEmail", "dirty"], true)
          .setIn(["signEmails", "dirty"], true)
      );
      let i = -1;
      let currentStep = this.props.questions.length;
      this.formData.get("values", Map()).map((v, k) => {
        i++;
        if (
          v.get("errors", []).length > 0 &&
          currentStep === this.props.questions.length
        ) {
          return (currentStep = i);
        }
      });

      this.setState({
        currentStep,
        formValid: false,
      });
    }
  };

  onDraft = () => {
    this.props.onSubmit({ values: this.getFormValues() }, true);
  };

  onSubmitterEmail = (data) => {
    if (this.props.submitterCopyEnabled) {
      this.mutate((state) => state.set("submitterEmail", data));
    }
  };

  onSignEmails = (data, dirty) => {
    if (dirty) {
      data = data.set("dirty", true);
    }

    this.mutate((state) => state.set("signEmails", data));
  };

  onClearForm = () => {
    if (this.props.onClearForm) {
      this.props.onClearForm();
    }
    setTimeout(() => {
      this.setState(
        {
          keyPrefix: unique(this.props.id),
          currentOptionQuestions: [],
          listLittera: [],
          formValid: null,
        },
        () => {
          // Force re-render and re-creation of nested components
          this.formRef.reset();
        }
      );
    });
  };

  prevStep = (currentStep) => {
    if (currentStep === 0) {
      if (!this.props.publicationDescription) {
        return;
      }
      this.setState({
        currentStep: undefined,
      });
    } else {
      if (currentStep > 0) {
        this.setState({
          currentStep: currentStep - 1,
        });
      } else {
        return;
      }
    }
  };

  nextStep = (currentStep) => {
    if (currentStep === undefined) {
      this.setState({
        currentStep: 0,
      });
    } else {
      if (this.props.sign || this.props.requiredIdentification.length > 0) {
        if (currentStep < this.props.questions.length) {
          this.setState({
            currentStep: currentStep + 1,
          });
        } else {
          return;
        }
      } else {
        if (currentStep < this.props.questions.length - 1) {
          this.setState({
            currentStep: currentStep + 1,
          });
        } else {
          return;
        }
      }
    }
  };

  componentDidMount() {
    if (this.state.fixedCustomer) {
      this.getLittera(this.state.fixedCustomer);
    }

    if (this.props.savedState && this.state.customerQuestion) {
      const customer =
        this.props.savedState.values[this.state.customerQuestion];
      if (customer && customer.rows.length > 0) {
        this.getLittera(customer.rows[0].text.split("_")[0]);
      }
    }
    if (typeof this.props.getContacts === "function") {
      this.props.getContacts().then((resp) => {
        this.setState({
          listAllContacts: resp.body.map((c) => ({
            label: c.contactName + " (" + c.contactEmail + ")",
            value: c.contactName + " (" + c.contactEmail + ")",
          })),
        });
      });
    }
    if (!this.props.publicationDescription) {
      this.setState({
        currentStep: 0,
      });
    }

    if (this.props.trackingCode) {
      ReactGA.initialize(this.props.trackingCode, {
        cookieDomain: "none",
        debug: true,
      });
      if (!!window.cordova) {
        ReactGA.ga("set", "checkProtocolTask", null);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.formData = this.initialFormData(nextProps);
    }
    if (nextProps.publicationDescription) {
      this.setState({
        currentStep: undefined,
      });
    } else {
      this.setState({
        currentStep: 0,
      });
    }
  }

  numErrors = () => {
    return (
      this.props.requiredIdentification.filter(
        (k) => this.formData.getIn([k, "text"], null) === null
      ).length |
      (0 +
        this.formData
          .get("values", Map())
          .filter((v) => v.get("errors").length > 0)
          .count()) |
      (0 +
        (this.props.sign
          ? this.formData.getIn(["sign", "errors"], []).length
          : 0)) |
      (0 +
        (this.props.secondarySign
          ? this.formData.getIn(["secondarySign", "errors"], []).length
          : 0)) |
      (0 +
        (this.props.submitterCopyEnabled &&
        this.formData.getIn(["submitterEmail", "enabled"], true)
          ? this.formData.getIn(
              ["submitterEmail", "errors"],
              ["question-required"]
            ).length
          : 0)) |
      (0 +
        (this.props.multiSign
          ? this.formData.getIn(["signEmails", "errors"], []).length
          : 0)) |
      0
    );
  };

  openHelpMessage = (message, title) => {
    if (Array.isArray(this.props.webHooks) && this.props.webHooks.length > 0) {
      let url = new URL(this.props.webHooks[0]);
      let companyId = url.searchParams.get("companyId");
      message = message.replace(
        'href="../',
        `href="./companies/${companyId}/publications/`
      );
    }

    message = message.replace(/href="(.*?)"/g, function (m, $1) {
      return (
        'href="' +
        $1 +
        '"' +
        " onclick=\"window.open('" +
        $1 +
        "', '_system'); return false;\""
      );
    });

    this.setState({
      helpMessage: message,
      helpMessageTitle: title,
      open: true,
    });
  };

  onCloseModal = () => {
    this.setState({
      open: false,
      helpMessage: "",
      helpMessageTitle: "",
    });
  };

  getOptionIndex = (index) => {
    let { currentOptionQuestions } = this.state;

    let i = currentOptionQuestions.findIndex((q) => index.id === q.id);
    if (i === -1) {
      currentOptionQuestions.push(index);
    } else {
      currentOptionQuestions[i].index = index.index;
    }

    let subQuestions = this.props.questions.filter((v, i) => {
      return v.parentId == index.id;
    });

    subQuestions.forEach((q) => {
      let input = this.formData.getIn(["values", q.id], Map());
      if (index.index === q.optionIndex) {
        input.errors = q.required ? ["question-required"] : [];
      } else {
        input = initQuestionData(q);
      }

      this.mutate((state) => state.setIn(["values", q.id], Map(input)));
    });

    this.setState({
      currentOptionQuestions,
    });
  };

  // cancelVerifyBankId = () => {
  //   request
  //     .delete(`${API_BASE}/collect-bankid`)
  //     .send({
  //       orderRef: "ae6fc2b7-936a-40b8-b27d-3b5bbaedb7ba",
  //     })
  //     .then((res) => {
  //       clearInterval(this.interval);
  //       this.interval = null;
  //     });
  // };

  // verifyBankId = () => {
  //   let url = new URL(this.props.webHooks[0]);
  //   let companyId = url.searchParams.get("companyId");
  //   this.mutate((state) => state.set("openVerifyBankId", true));
  //   request
  //     .post(`${API_BASE}/auth-bankid`)
  //     .send({
  //       companyId: companyId,
  //       personalNumber: this.state.get("personalNumber"),
  //     })
  //     .then((res) => {
  //       let { orderRef } = res.body;
  //       this.interval = setInterval(() => {
  //         request
  //           .post(`${API_BASE}/collect-bankid`)
  //           .send({
  //             orderRef,
  //           })
  //           .then((res) => {
  //             if (res.body.status === "complete") {
  //               clearInterval(this.interval);
  //               this.interval = null;
  //               this.mutate((state) =>
  //                 state
  //                   .setIn(
  //                     ["ORGANIZATION_NUMBER", "text"],
  //                     res.body.completionData.user.personalNumber
  //                   )
  //                   .setIn(["NAME", "text"], res.body.completionData.user.name)
  //                   .set("bankIdVerified", true)
  //                   .set("openVerifyBankId", false)
  //               );
  //             }
  //           });
  //       }, 2000);
  //     });
  // };

  componentWillUnmount() {
    this.formData = null;
  }

  render() {
    let ids = ICOMPONENTS.map((c) => {
      if (this.props.requiredIdentification.indexOf(c.key) !== -1) {
        return (
          <c.component
            key={c.key}
            type={c.key}
            data={this.formData.get(c.key, Map())}
            onChange={this.onID}
          />
        );
      }

      return false;
    })
      .filter((k) => k)
      .filter((c) => c.key !== "NAME" || !this.props.secondarySign);

    let {
      currentStep,
      submitting,
      keyPrefix,
      listLittera,
      listAllContacts,
      formValid,
      open,
      helpMessageTitle,
      helpMessage,
    } = this.state;

    return this.props.layoutFormType === "step" ? (
      <div className="form__wrap">
        <form ref={(el) => (this.formRef = el)}>
          <div className="form__wrap-step-by-step">
            <div className="share__step-body">
              {currentStep === undefined ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.props.publicationDescription,
                  }}
                />
              ) : null}
              {currentStep !== undefined &&
              currentStep < this.props.questions.length ? (
                <ul className="question__wrap row cf">
                  <Question
                    key={keyPrefix + this.props.questions[currentStep].id}
                    openHelpMessage={this.openHelpMessage}
                    {...this.props.questions[currentStep]}
                    onInput={this.onInput}
                    listLittera={listLittera}
                    data={this.formData.getIn(
                      ["values", this.props.questions[currentStep].id],
                      Map()
                    )}
                    listSources={this.props.listSources}
                    listSourceToText={this.props.listSourceToText}
                    listAllContacts={listAllContacts}
                    companyId={this.props.companyId}
                    queryCustomers={this.props.queryCustomers}
                    queryProducts={this.props.queryProducts}
                    getOptionList={this.props.getOptionList}
                    queryUnits={this.props.queryUnits}
                  />
                </ul>
              ) : null}

              {ids.length > 0 && currentStep === this.props.questions.length ? (
                <div className="row">
                  <T component="h3">identification</T>
                  <ul className="verification row cf">{ids}</ul>
                </div>
              ) : null}

              {this.props.sign &&
              currentStep === this.props.questions.length ? (
                <Sign
                  onInput={this.onSign}
                  data={this.formData.get("sign", Map())}
                  name={this.props.secondarySign}
                  customTitle={this.props.meta.customSignatureHeader || ""}
                />
              ) : null}

              {this.props.secondarySign &&
              currentStep === this.props.questions.length ? (
                <SecondarySign
                  onInput={this.onSecondarySign}
                  data={this.formData.get("secondarySign", Map())}
                  name={true}
                  customTitle={this.props.meta.customSignatureHeader1 || ""}
                />
              ) : null}
            </div>
          </div>

          <div className="form__step-footer">
            <div>
              {this.props.submitterCopyEnabled ? (
                <SubmitterEmail
                  data={this.formData.get("submitterEmail", Map())}
                  onChange={this.onSubmitterEmail}
                />
              ) : null}

              {this.props.multiSign ? (
                <SignEmails
                  data={this.formData.get("signEmails", Map())}
                  isRequired={this.props.multiSignRequired}
                  onChange={this.onSignEmails}
                  keyPrefix={keyPrefix}
                  signMultipleFields={this.props.signMultipleFields}
                  signNumOfFields={this.props.signNumOfFields}
                  signFixEmails={this.props.signFixEmails}
                  meta={this.props.meta}
                />
              ) : null}

              {this.props.onClearForm ? (
                <button
                  type="button"
                  className="button print-hide"
                  onClick={this.onClearForm}
                  disabled={submitting}
                >
                  <i className="fa fa-remove" />

                  <T>clear-form</T>
                </button>
              ) : null}
              <div className="publication-edit__wrap button__bar--break-tiny">
                <button
                  type="button"
                  className="button"
                  onClick={() => this.prevStep(currentStep)}
                >
                  <T>back</T>
                </button>
                {((this.props.sign ||
                  this.props.requiredIdentification.length > 0) &&
                  currentStep < this.props.questions.length) ||
                (!this.props.sign &&
                  this.props.requiredIdentification.length === 0 &&
                  currentStep < this.props.questions.length - 1) ||
                currentStep === undefined ? (
                  <button
                    type="button"
                    className="button"
                    onClick={() => this.nextStep(currentStep)}
                  >
                    <T>next</T>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="button button--system print-hide"
                    onClick={this.onSubmit}
                    disabled={submitting}
                  >
                    <i className="fa fa-send-o" />

                    <T>submit</T>
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    ) : (
      <div
        className="form__wrap"
        style={{
          position: this.props.clearBtnOnTop ? "initial" : "relative",
        }}
      >
        <form
          ref={(el) => (this.formRef = el)}
          style={{
            position: this.props.clearBtnOnTop ? "initial" : "relative",
          }}
        >
          {this.props.onClearForm && this.props.clearBtnOnTop ? (
            <div className="form__clear-btn hide-below-tiny">
              <button
                type="button"
                className="button print-hide"
                onClick={this.onClearForm}
                disabled={submitting}
              >
                <i className="fa fa-remove" />

                <T>clear-form</T>
              </button>
            </div>
          ) : null}
          {Array.isArray(this.props.meta.tags) && (
            <div className="row">
              <div className="question__tags-wrapper button__bar--break-tiny">
                <button
                  onClick={() => {
                    this.setState({
                      currentTag: "",
                    });
                  }}
                  className={classNames("button", {
                    active: !this.state.currentTag,
                  })}
                  type="button"
                >
                  <T>see-all-questions</T>
                </button>

                {this.props.meta.tags.map((tag, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      this.setState({
                        currentTag: tag,
                      });
                    }}
                    type="button"
                    className={classNames("button", {
                      active: tag === this.state.currentTag,
                    })}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          )}
          <ul className="question__wrap row cf">
            {this.props.questions
              .filter((q) => !q.parentId)
              .filter(
                (q) =>
                  (this.state.currentTag &&
                    Array.isArray(q.meta.tags) &&
                    q.meta.tags.includes(this.state.currentTag)) ||
                  !this.state.currentTag
              )
              .map((q, i) => {
                if (q.type === "HEADING" || q.type === "DIVIDER") {
                  return (
                    <Question
                      {...q}
                      openHelpMessage={this.openHelpMessage}
                      listLittera={listLittera}
                      onInput={this.onInput}
                      data={this.formData.getIn(["values", q.id], Map())}
                      listSources={this.props.listSources}
                      listSourceToText={this.props.listSourceToText}
                      listAllContacts={listAllContacts}
                      allData={this.props.questions.map((v) => {
                        return {
                          question: v,
                          data: this.formData.getIn(["values", v.id], Map()),
                        };
                      })}
                      companyId={this.props.companyId}
                      queryCustomers={this.props.queryCustomers}
                      queryProducts={this.props.queryProducts}
                      getOptionList={this.props.getOptionList}
                      queryUnits={this.props.queryUnits}
                    />
                  );
                }
                return (
                  <li key={keyPrefix + q.id} className={questionClasses(q)}>
                    <Question
                      {...q}
                      openHelpMessage={this.openHelpMessage}
                      listLittera={listLittera}
                      onInput={this.onInput}
                      data={this.formData.getIn(["values", q.id], Map())}
                      listSources={this.props.listSources}
                      listSourceToText={this.props.listSourceToText}
                      listAllContacts={listAllContacts}
                      companyId={this.props.companyId}
                      allData={this.props.questions.map((v) => {
                        return {
                          question: v,
                          data: this.formData.getIn(["values", v.id], Map()),
                        };
                      })}
                      getOptionIndex={
                        q.type === "RADIO" ? this.getOptionIndex : null
                      }
                      companyId={this.props.companyId}
                      queryCustomers={this.props.queryCustomers}
                      queryProducts={this.props.queryProducts}
                      getOptionList={this.props.getOptionList}
                      queryUnits={this.props.queryUnits}
                    />
                    {q.type === "RADIO"
                      ? this.props.questions
                          .filter((sq) => {
                            let x = this.state.currentOptionQuestions.find(
                              (cq) => {
                                return cq.id === q.id;
                              }
                            );
                            return (
                              sq.parentId &&
                              sq.parentId === q.id &&
                              x &&
                              x.index === sq.optionIndex
                            );
                          })
                          .map((sq) => (
                            <div
                              key={keyPrefix + sq.id}
                              className="row question__sub-question"
                            >
                              <Question
                                {...sq}
                                className="row"
                                openHelpMessage={this.openHelpMessage}
                                listLittera={listLittera}
                                onInput={this.onInput}
                                data={this.formData.getIn(
                                  ["values", sq.id],
                                  Map()
                                )}
                                listSources={this.props.listSources}
                                listSourceToText={this.props.listSourceToText}
                                companyId={this.props.companyId}
                                listAllContacts={listAllContacts}
                                allData={this.props.questions.map((v) => {
                                  return {
                                    question: v,
                                    data: this.formData.getIn(
                                      ["values", v.id],
                                      Map()
                                    ),
                                  };
                                })}
                                companyId={this.props.companyId}
                                queryCustomers={this.props.queryCustomers}
                                queryProducts={this.props.queryProducts}
                                getOptionList={this.props.getOptionList}
                                queryUnits={this.props.queryUnits}
                              />
                            </div>
                          ))
                      : null}
                  </li>
                );
              })}
          </ul>

          {ids.length > 0 ? (
            <div className="separator row">
              <T component="h3">identification</T>
              <ul className="verification row cf">{ids}</ul>
            </div>
          ) : null}

          {this.props.sign ? (
            <Sign
              onInput={this.onSign}
              data={this.formData.get("sign", Map())}
              name={this.props.secondarySign}
              customTitle={this.props.meta.customSignatureHeader || ""}
            />
          ) : null}

          {this.props.secondarySign ? (
            <SecondarySign
              onInput={this.onSecondarySign}
              data={this.formData.get("secondarySign", Map())}
              name={true}
              customTitle={this.props.meta.customSignatureHeader1 || ""}
            />
          ) : null}

          <div className="row separator cf">
            {this.props.submitterCopyEnabled ? (
              <SubmitterEmail
                data={this.formData.get("submitterEmail", Map())}
                onChange={this.onSubmitterEmail}
              />
            ) : null}

            {this.props.multiSign ? (
              <SignEmails
                data={this.formData.get("signEmails", Map())}
                isRequired={this.props.multiSignRequired}
                onChange={this.onSignEmails}
                keyPrefix={keyPrefix}
                signMultipleFields={this.props.signMultipleFields}
                signNumOfFields={this.props.signNumOfFields}
                signFixEmails={this.props.signFixEmails}
                meta={this.props.meta}
              />
            ) : null}
            {
              // {this.props.useBankId && !this.state.get("bankIdVerified", false) && (
              //   <div className="row container--slim">
              //     <h4 className="text-height">
              //       <T>verify-with-bankid</T>
              //     </h4>
              //     <div className="cf">
              //       <input
              //         className="line-component"
              //         type="text"
              //         style={{ height: "35px", marginRight: ".7rem" }}
              //         placeholder={this.context.translate.translate(
              //           "identification-questions.SOCIAL_SECURITY_NUMBER"
              //         )}
              //         value={this.state.get("personalNumber", "")}
              //         onChange={(e) => {
              //           this.mutate((state) =>
              //             state.set("personalNumber", e.target.value)
              //           );
              //         }}
              //       />
              //       <button
              //         className="line-component--omega"
              //         onClick={() => {
              //           this.verifyBankId(this.state.get("personalNumber"));
              //         }}
              //         disabled={!this.state.get("personalNumber", "")}
              //         type="button"
              //         className="button button--system"
              //       >
              //         <T>ok</T>
              //         <img
              //           width="20"
              //           style={{ marginLeft: "15px" }}
              //           src="/images/bank-id-ico.png"
              //           alt="Bank Id"
              //         />
              //       </button>
              //     </div>
              //   </div>
              // )}
            }

            {
              //   {this.props.useBankId && !this.state.get("bankIdVerified", false) && (
              //   <div className="row container--slim">
              //     <h4 className="text-height">
              //       <T>verify-with-bankid</T>
              //     </h4>
              //     <div className="cf">
              //       <input
              //         className="line-component"
              //         type="text"
              //         style={{ height: "35px", marginRight: ".7rem" }}
              //         placeholder={this.context.translate.translate(
              //           "identification-questions.SOCIAL_SECURITY_NUMBER"
              //         )}
              //         value={this.state.get("personalNumber", "")}
              //         onChange={(e) => {
              //           this.mutate((state) =>
              //             state.set("personalNumber", e.target.value)
              //           );
              //         }}
              //       />
              //       <button
              //         className="line-component--omega"
              //         onClick={() => {
              //           this.verifyBankId(this.state.get("personalNumber"));
              //         }}
              //         disabled={!this.state.get("personalNumber", "")}
              //         type="button"
              //         className="button button--system"
              //       >
              //         <T>ok</T>
              //         <img
              //           width="20"
              //           style={{ marginLeft: "15px" }}
              //           src="/images/bank-id-ico.png"
              //           alt="Bank Id"
              //         />
              //       </button>
              //     </div>
              //   </div>
              // )}
            }

            <button
              type="button"
              className="button button--system print-hide"
              onClick={this.onSubmit}
              disabled={submitting}
            >
              <i className="fa fa-send-o" />
              <T>submit</T>
            </button>

            {this.props.onClearForm ? (
              <button
                type="button"
                className={classNames("button", "print-hide", {
                  "hide-above-tiny": this.props.clearBtnOnTop,
                })}
                onClick={this.onClearForm}
                disabled={submitting}
              >
                <i className="fa fa-remove" />

                <T>clear-form</T>
              </button>
            ) : null}

            {!!window.cordova && (
              <button
                type="button"
                className={classNames("button button--negative", "print-hide")}
                onClick={this.onDraft}
                disabled={submitting}
              >
                <i style={{ margin: 0 }} className="fa fa-floppy-o" />
              </button>
            )}

            {(typeof formValid === "boolean" && typeof formValid === false) ||
            (typeof formValid === "boolean" && this.numErrors() > 0) ? (
              <T
                className="validation__message validation__missing-required-fields"
                component="p"
              >
                {"missing-required-fields"}
              </T>
            ) : null}
          </div>
          <div className="row hide-below-tiny">
            {Array.isArray(this.props.webHooks) &&
            this.props.webHooks.some(
              (h) => h.indexOf("save-a-copy-form") > 1
            ) ? (
              <span>
                <em>
                  <T>a-copy-will-be-downloaded</T>
                </em>
              </span>
            ) : null}
          </div>
        </form>
        <Modal
          open={open}
          onClose={() => {
            this.onCloseModal();
          }}
          little
        >
          <h3>
            <T>information</T> - {helpMessageTitle}
          </h3>
          <div className="separator">
            <p
              style={{ minHeight: "10rem" }}
              dangerouslySetInnerHTML={{
                __html: helpMessage,
              }}
            />
          </div>
        </Modal>

        {
          //   <Modal
          //   onClose={() => {}}
          //   center
          //   showCloseIcon={false}
          //   open={this.state.get("openVerifyBankId", false)}
          //   little
          // >
          //   <div className="row--large text-center">&nbsp;</div>
          //   <h3 className="row--large text-center">
          //     <T>identify-on-dokiv</T>
          //   </h3>
          //   <div className="row--large text-center">
          //     <i className="fa fa-5x fa-spinner fa-spin"></i>
          //   </div>
          //   <div className="row--large text-center">
          //     <T>please-open-bankid-app</T>
          //   </div>
          //   <div className="row--large text-center">&nbsp;</div>
          //   <div className="separator text-center">
          //     <button
          //       className="button button--negative"
          //       onClick={() => {
          //         this.cancelVerifyBankId();
          //         this.mutate((state) => state.set("openVerifyBankId", false));
          //       }}
          //       type="button"
          //     >
          //       <T>cancel-verify</T>
          //     </button>
          //   </div>
          // </Modal>
        }
      </div>
    );
  }
}

Renderer.propTypes = {
  id: PropTypes.string.isRequired,
  previousVersionId: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  anonymous: PropTypes.bool,
  requiredIdentification: PropTypes.arrayOf(PropTypes.oneOf(ITYPES)),
  sign: PropTypes.bool,
  secondarySign: PropTypes.bool,
  active: PropTypes.bool,
  submitterCopyEnabled: PropTypes.bool.isRequired,
  thankMessage: PropTypes.string,
  questions: PropTypes.arrayOf(PropTypes.object),
  /* Interaction, not part of form spec: */
  onSubmit: PropTypes.func.isRequired,
  /* Invoked every time the user changes the data with the new data */
  onData: PropTypes.func,
  /* Invoked when the user clicks the clear-form button */
  onClearForm: PropTypes.func,
  prevStep: PropTypes.func,
  nextStep: PropTypes.func,
  /* Object with data from the onData callback, JS format of the format specified for the Render class */
  savedState: PropTypes.object,
  /* Data to select for the specified sources */
  listSources: PropTypes.object,
  listSourceToText: PropTypes.func,
  multiSign: PropTypes.bool.isRequired,
};

Renderer.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
  }).isRequired,
};

Renderer.defaultProps = {
  description: "",
  anonymous: false,
  requiredIdentification: [],
  sign: false,
  active: true,
  thankMessage: "",
  submitterEmail: null,
  questions: [],
  multiSign: false,
};
